import React, { useRef } from 'react';

const LENGTH = 6;

/**
 * Verification code input (6 digits) with paste and keyboard navigation support.
 */
const CodeInput = ({ value = '', onChange, onComplete, disabled }) => {
    const refs = useRef([]);
    const digits = Array.from({ length: LENGTH }, (_, i) => value[i] || '');

    const update = (nextDigits) => {
        const code = nextDigits.join('');
        onChange(code);
        if (code.length === LENGTH && onComplete) onComplete(code);
    };

    const handleChange = (index, event) => {
        const digit = event.target.value.replace(/\D/g, '').slice(-1);
        const next = [...digits];
        next[index] = digit;
        update(next);
        if (digit && index < LENGTH - 1) refs.current[index + 1].focus();
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !digits[index] && index > 0) {
            refs.current[index - 1].focus();
        } else if (event.key === 'ArrowLeft' && index > 0) {
            refs.current[index - 1].focus();
        } else if (event.key === 'ArrowRight' && index < LENGTH - 1) {
            refs.current[index + 1].focus();
        }
    };

    const handlePaste = (event) => {
        const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, LENGTH);
        if (!pasted) return;
        event.preventDefault();
        update(Array.from({ length: LENGTH }, (_, i) => pasted[i] || ''));
        refs.current[Math.min(pasted.length, LENGTH - 1)].focus();
    };

    return (
        <div className="psp-code" role="group" aria-label="Código de verificação">
            {digits.map((digit, index) => (
                <input
                    key={index}
                    ref={(el) => (refs.current[index] = el)}
                    className="psp-code__digit"
                    type="text"
                    inputMode="numeric"
                    autoComplete={index === 0 ? 'one-time-code' : 'off'}
                    maxLength={1}
                    value={digit}
                    disabled={disabled}
                    onChange={(event) => handleChange(index, event)}
                    onKeyDown={(event) => handleKeyDown(index, event)}
                    onPaste={handlePaste}
                    aria-label={`Dígito ${index + 1}`}
                />
            ))}
        </div>
    );
};

export default CodeInput;
